(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function loopHours(root) {
    var raw = parseFloat(root.getAttribute('data-loop') || '');
    return raw > 0 ? raw : 0;
  }

  function remaining(root) {
    var hours = loopHours(root);
    if (hours) {
      var period = hours * 60 * 60 * 1000;
      var left = period - (Date.now() % period);
      return left > 0 ? left : period;
    }
    var end = Date.parse(root.getAttribute('data-end') || '');
    if (!end) return 0;
    return end - Date.now();
  }

  function tick(root) {
    var left = remaining(root);
    var looping = loopHours(root) > 0;
    var ended = root.querySelector('[data-ended]');
    var running = root.querySelector('[data-running]');
    if (left <= 0 && !looping) {
      if (running) running.hidden = true;
      if (ended) ended.hidden = false;
      return;
    }
    if (ended) ended.hidden = true;
    if (running) running.hidden = false;
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    s -= d * 86400;
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    if (!root.querySelector('[data-unit="days"]')) {
      h += d * 24;
      d = 0;
    }
    var set = function (name, value) {
      var el = root.querySelector('[data-unit="' + name + '"]');
      if (el) el.textContent = name === 'days' ? String(value) : pad(value);
    };
    set('days', d);
    set('hours', h);
    set('mins', m);
    set('secs', s);
  }

  function start() {
    document.querySelectorAll('[data-pupprint-countdown]').forEach(function (root) {
      tick(root);
      setInterval(function () {
        tick(root);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
